"use client";

import { useCallback, useEffect } from "react";
import { Cookies, getCookieConsentValue } from "react-cookie-consent";
import { useCmp } from "../../organism/CMP/context";
import TagManager from "react-gtm-module";

const tagManagerArgs: any = {
  gtmId: process.env.NEXT_PUBLIC_TAG_MANAGER_ID,
};

export const useTracking = () => {
  const { hasAcceptedConsents, setHasAcceptedConsents } = useCmp();

  const initialize = useCallback(() => {
    TagManager.initialize(tagManagerArgs);
    setHasAcceptedConsents(true);
  }, [setHasAcceptedConsents]);

  const untrack = () => {
    Cookies.remove("_ga");
    Cookies.remove("_gat");
    Cookies.remove("_gid");

    setHasAcceptedConsents(false);
    window.location.reload(); // reload page to disable GTM
  };

  useEffect(() => {
    const isConsent = getCookieConsentValue();
    setHasAcceptedConsents(isConsent === "true");
  }, [setHasAcceptedConsents]);

  useEffect(() => {
    hasAcceptedConsents && initialize();
  }, [hasAcceptedConsents, initialize]);

  return { initialize, untrack };
};
